module.exports = __webpack_public_path__ + "media/logos/wsj-black-159a2391.jpg";